import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "sonner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            border: "2px solid #09090b",
            boxShadow: "4px 4px 0 0 #09090b",
            borderRadius: 0,
            background: "#fff",
            color: "#09090b",
            fontFamily: "Manrope, sans-serif",
            fontWeight: 600,
          },
        }}
      />
    </AuthProvider>
  </React.StrictMode>,
);
